import { render } from "./additional-documents-modal.html?vue&type=template&id=57f7dc0d&scoped=true&ts=true&external"
import script from "./additional-documents-modal.ts?vue&type=script&lang=ts&external"
export * from "./additional-documents-modal.ts?vue&type=script&lang=ts&external"

import "./additional-documents-modal.scss?vue&type=style&index=0&id=57f7dc0d&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f7dc0d"]])

export default __exports__